// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.106.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.106.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fix for shadcn sidebar with Tailwind v4 */
/* This file is imported separately to avoid Tailwind processing */

:root {
  --sidebar-width: 16rem;
  --sidebar-width-icon: 3rem;
}

/* Base sidebar width - applies when expanded */
.group.peer > div:first-child {
  width: var(--sidebar-width);
}

/* Collapsed (icon) mode - when data-collapsible="icon" */
.group.peer[data-collapsible="icon"] > div:first-child {
  width: var(--sidebar-width-icon);
}

/* Fixed sidebar panel width */
.group.peer > div:nth-child(2) {
  width: var(--sidebar-width);
}

.group.peer[data-collapsible="icon"] > div:nth-child(2) {
  width: var(--sidebar-width-icon);
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebar-fix.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,kEAAkE;;AAElE;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* Fix for shadcn sidebar with Tailwind v4 */\n/* This file is imported separately to avoid Tailwind processing */\n\n:root {\n  --sidebar-width: 16rem;\n  --sidebar-width-icon: 3rem;\n}\n\n/* Base sidebar width - applies when expanded */\n.group.peer > div:first-child {\n  width: var(--sidebar-width);\n}\n\n/* Collapsed (icon) mode - when data-collapsible=\"icon\" */\n.group.peer[data-collapsible=\"icon\"] > div:first-child {\n  width: var(--sidebar-width-icon);\n}\n\n/* Fixed sidebar panel width */\n.group.peer > div:nth-child(2) {\n  width: var(--sidebar-width);\n}\n\n.group.peer[data-collapsible=\"icon\"] > div:nth-child(2) {\n  width: var(--sidebar-width-icon);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
